import { render, staticRenderFns } from "./QuickReplies.vue?vue&type=template&id=26e3f900&"
import script from "./QuickReplies.vue?vue&type=script&lang=js&"
export * from "./QuickReplies.vue?vue&type=script&lang=js&"
import style0 from "./QuickReplies.vue?vue&type=style&index=0&id=26e3f900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports